import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  message,
  Upload,
  Layout,
  Space,
  List,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axiosInstance from "../api/axiosInstance";
import Sidebar from "../components/Sidebar";
import AppHeader from "../components/Header";

const { Content } = Layout;

const MeetingFollowup = () => {
  const [meetings, setMeetings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isDetailModalVisible, setIsDetailModalVisible] = useState(false);
  const [currentMeeting, setCurrentMeeting] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [buktiFiles, setBuktiFiles] = useState([]); // Simpan file bukti

  useEffect(() => {
    fetchUserMeetings();
  }, []);

  const fetchUserMeetings = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get("/history-meeting/user");
      setMeetings(res.data);
    } catch (error) {
      message.error("Gagal mengambil daftar meeting");
    }
    setLoading(false);
  };

  const fetchBuktiFiles = async (id_meeting) => {
    try {
      const res = await axiosInstance.get(`/bukti/${id_meeting}`);
      setBuktiFiles(res.data);
    } catch (error) {
      message.error("Gagal mengambil bukti tindak lanjut");
    }
  };

  const handleUpdate = async (values) => {
    try {
      if (!currentMeeting || !currentMeeting.Meeting?.id_meeting) {
        message.error("ID meeting tidak ditemukan!");
        return;
      }

      const formData = new FormData();
      formData.append("id_history_meeting", currentMeeting.id_history_meeting);
      formData.append("id_meeting", currentMeeting.Meeting.id_meeting);
      formData.append("issue", values.issue);
      formData.append("tindak_lanjut", values.tindak_lanjut);

      fileList.forEach((file) => {
        formData.append("bukti", file.originFileObj);
      });

      await axiosInstance.post("/history-meeting/update", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      message.success("Hasil meeting berhasil disimpan");
      fetchUserMeetings();
      setIsModalVisible(false);
      setCurrentMeeting(null);
      setFileList([]);
    } catch (error) {
      message.error("Gagal menyimpan hasil meeting");
    }
  };

  const columns = [
    {
      title: "Project",
      dataIndex: ["Meeting", "Project", "nama_project"],
      key: "project",
    },
    {
      title: "Tanggal Meeting",
      dataIndex: ["Meeting", "waktu_meeting"],
      key: "waktu_meeting",
    },
    { title: "Issue", dataIndex: "issue", key: "issue" },
    {
      title: "Tindak Lanjut",
      dataIndex: "tindak_lanjut",
      key: "tindak_lanjut",
    },
    {
      title: "Aksi",
      render: (text, record) => (
        <Space>
          <Button
            type="primary"
            onClick={() => {
              setCurrentMeeting(record);
              setIsModalVisible(true);
            }}
          >
            Edit
          </Button>
          <Button
            type="default"
            onClick={() => {
              setCurrentMeeting(record);
              fetchBuktiFiles(record.id_history_meeting);
              setIsDetailModalVisible(true);
            }}
          >
            Detail
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout style={{ marginLeft: 260 }}>
        {/* Menyesuaikan lebar sidebar */}
        <AppHeader />
        <Content
          style={{
            margin: "20px",
            padding: "20px",
            background: "#fff",
            minHeight: "100vh",
          }}
        >
          <h2>Tindak Lanjut Meeting</h2>
          <Table
            columns={columns}
            dataSource={meetings}
            loading={loading}
            rowKey="id_history_meeting"
          />

          {/* Modal Edit */}
          <Modal
            title="Update Tindak Lanjut"
            visible={isModalVisible}
            onCancel={() => setIsModalVisible(false)}
            footer={null}
          >
            <Form
              initialValues={currentMeeting}
              onFinish={handleUpdate}
              layout="vertical"
            >
              <Form.Item label="Issue" name="issue">
                <Input.TextArea />
              </Form.Item>
              <Form.Item label="Tindak Lanjut" name="tindak_lanjut">
                <Input.TextArea />
              </Form.Item>
              <Form.Item label="Upload Bukti (Opsional)">
                <Upload
                  multiple
                  beforeUpload={() => false}
                  onChange={({ fileList }) => setFileList(fileList)}
                  fileList={fileList}
                  maxCount={5}
                >
                  <Button icon={<UploadOutlined />}>Upload Bukti</Button>
                </Upload>
              </Form.Item>
              <Button type="primary" htmlType="submit">
                Simpan
              </Button>
            </Form>
          </Modal>

          {/* Modal Detail */}
          <Modal
            title="Detail Tindak Lanjut"
            visible={isDetailModalVisible}
            onCancel={() => setIsDetailModalVisible(false)}
            footer={null}
          >
            <h3>Issue:</h3>
            <p>{currentMeeting?.issue || "-"}</p>

            <h3>Tindak Lanjut:</h3>
            <p>{currentMeeting?.tindak_lanjut || "-"}</p>

            <h3>Bukti:</h3>
            {buktiFiles.length > 0 ? (
              <List
                bordered
                dataSource={buktiFiles}
                renderItem={(item) => (
                  <List.Item>
                    <a
                      href={item.file_path}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {item.uraian}
                    </a>
                  </List.Item>
                )}
              />
            ) : (
              <p>Tidak ada bukti</p>
            )}
          </Modal>
        </Content>
      </Layout>
    </Layout>
  );
};

export default MeetingFollowup;
